import React, { useState } from "react";
import "../../styles/audiobook/SelectMode.scss";
import useAppTranslation from "../../hooks/useAppTranslation";

const SelectMode = ({ onSelect, onNext, onClose }) => {
  const { t, language } = useAppTranslation("components/audiobook/selectMode");
  const [selected, setSelected] = useState(null);
  const isRussian = language === "ru";
  const audioDesc = {
    voice: t("descriptions.voice"),
    ai: t("descriptions.ai"),
    myVoiceWithAI: t("descriptions.myVoiceWithAI"),
  };

  const audioTitle = {
    voice: t("detailTitles.voice"),
    ai: t("detailTitles.ai"),
    myVoiceWithAI: t("detailTitles.myVoiceWithAI"),
  };

  return (
    <>
      <figure className="close-select-mode" onClick={onClose}>
        <img
          src={"/images/audiobook/guide-text-close.svg"}
          alt={t("actions.close")}
        />
      </figure>
      <div
        className={`audio-explain-container ${isRussian ? "ru-text-center" : ""}`}
      >
        <p className="step-text">{t("step")}</p>
        <h3>{t("title")}</h3>
        <p className="step-desc">{t("description")}</p>
      </div>
      <ul className="audio-selection-list">
        <li
          className={selected === "voice" ? "selected" : ""}
          onClick={() => {
            setSelected("voice");
          }}
        >
          <p>{t("options.voice")}</p>
          <figure>
            <img src={"/images/audiobook/audio-selection-1.svg"} alt="" />
          </figure>
        </li>
        <li
          className={selected === "ai" ? "selected" : ""}
          onClick={() => {
            setSelected("ai");
          }}
        >
          <p>{t("options.ai")}</p>
          <figure>
            <img src={"/images/audiobook/audio-selection-2.svg"} alt="" />
          </figure>
        </li>
        <li
          className={selected === "myVoiceWithAI" ? "selected" : ""}
          onClick={() => {
            setSelected("myVoiceWithAI");
          }}
        >
          <div className="beta-tag">{t("betaTag")}</div>
          <p>
            {t("options.myVoiceWithAI.line1")}
            <br /> {t("options.myVoiceWithAI.line2")}
          </p>
          <figure>
            <img src={"/images/audiobook/audio-selection-3.svg"} alt="" />
          </figure>
        </li>
      </ul>
      {selected ? (
        <div className="audio-desc-text">
          <div className={`light-text ${isRussian ? "ru-text-center" : ""}`}>
            <figure>
              <img src={"/images/utils/light.svg"} alt={t("detailIconAlt")} />
            </figure>
            <h4>{audioTitle[selected] || ""}</h4>
          </div>
          <p className="audio-desc">{audioDesc[selected] || ""}</p>
        </div>
      ) : null}
      {selected && (
        <button
          type="button"
          className="next-btn"
          onClick={() => {
            onSelect(selected);
            onNext();
          }}
        >
          <span>{t("actions.confirm")}</span>
        </button>
      )}
    </>
  );
};

export default SelectMode;
